import React from "react";

import Fade from "react-reveal/Fade";

import {
  Container,
  Wrapper,
  Image,
  TextWrapper,
  TitleText,
  ItemWrapper,
  Heading,
  Text
} from "./styles";

export default function Breakdown({
  reversed = false,
  image,
  title,
  items = []
}) {
  return (
    <Container>
      <Wrapper>
        <Fade left>{!reversed && <Image src={image} />}</Fade>

        <Fade left={reversed} right={!reversed}>
          <TextWrapper reversed={reversed}>
            <TitleText>{title}</TitleText>
            {items.map((item, index) => {
              const { heading, text } = item;
              return (
                <ItemWrapper key={index}>
                  <Heading>{heading}</Heading>
                  <Text>{text}</Text>
                </ItemWrapper>
              );
            })}
          </TextWrapper>
        </Fade>

        <Fade right>{reversed && <Image src={image} />}</Fade>
      </Wrapper>
    </Container>
  );
}
